import { render, staticRenderFns } from "./HorizontalLineWidget.vue?vue&type=template&id=4de4051c&scoped=true"
import script from "./HorizontalLineWidget.vue?vue&type=script&lang=js"
export * from "./HorizontalLineWidget.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLineWidget.vue?vue&type=style&index=0&id=4de4051c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4051c",
  null
  
)

export default component.exports